import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const NoteGraph: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_31223)'>
        <path
          d='M20.9272 5.21911L16.5124 1.066C16.4655 1.02444 16.4057 1 16.3433 1H4.45602C3.65261 1 3 1.61356 3 2.36889V21.6311C3 22.3864 3.65261 23 4.45602 23H19.544C20.3474 23 21 22.3864 21 21.6311V5.37556C20.9974 5.31689 20.9714 5.26067 20.9272 5.21911ZM16.58 1.76756L20.181 5.15311H17.256C16.8842 5.15311 16.5826 4.86956 16.5826 4.52V1.76756H16.58ZM19.5414 22.5502H4.45602C3.91781 22.5502 3.47841 22.1371 3.47841 21.6311V2.36889C3.47841 1.86289 3.91781 1.44978 4.45602 1.44978H16.1041V4.52C16.1041 5.11644 16.6216 5.60289 17.256 5.60289H20.5216V21.6311C20.519 22.1396 20.0822 22.5502 19.5414 22.5502ZM5.46743 4.18022C5.46743 4.05556 5.57403 3.95533 5.70663 3.95533H14.4167C14.5493 3.95533 14.6559 4.05556 14.6559 4.18022C14.6559 4.30489 14.5493 4.40511 14.4167 4.40511H5.70663C5.57403 4.40511 5.46743 4.30489 5.46743 4.18022ZM17.7916 11.6456H15.9117C15.5035 11.6456 15.1733 11.956 15.1733 12.3398V19.348C15.1733 19.7318 15.5035 20.0422 15.9117 20.0422H17.7916C18.1998 20.0422 18.53 19.7318 18.53 19.348V12.3398C18.53 11.9584 18.1998 11.6456 17.7916 11.6456ZM18.0542 19.3504C18.0542 19.4849 17.9372 19.5949 17.7942 19.5949H15.9143C15.7713 19.5949 15.6543 19.4849 15.6543 19.3504V12.3398C15.6543 12.2053 15.7713 12.0953 15.9143 12.0953H17.7942C17.9372 12.0953 18.0542 12.2053 18.0542 12.3398V19.3504ZM8.57966 15.6496H6.69984C6.29164 15.6496 5.96143 15.96 5.96143 16.3438V19.3504C5.96143 19.7342 6.29164 20.0447 6.69984 20.0447H8.57966C8.98787 20.0447 9.31807 19.7342 9.31807 19.3504V16.3438C9.31807 15.96 8.98527 15.6496 8.57966 15.6496ZM8.83966 19.3504C8.83966 19.4849 8.72266 19.5949 8.57966 19.5949H6.69984C6.55684 19.5949 6.43984 19.4849 6.43984 19.3504V16.3438C6.43984 16.2093 6.55684 16.0993 6.69984 16.0993H8.57966C8.72266 16.0993 8.83966 16.2093 8.83966 16.3438V19.3504ZM13.1843 13.6476H11.3045C10.8963 13.6476 10.5661 13.958 10.5661 14.3418V19.3504C10.5661 19.7342 10.8963 20.0447 11.3045 20.0447H13.1843C13.5925 20.0447 13.9227 19.7342 13.9227 19.3504V14.3418C13.9227 13.958 13.5925 13.6476 13.1843 13.6476ZM13.4469 19.3504C13.4469 19.4849 13.3299 19.5949 13.1869 19.5949H11.3071C11.1641 19.5949 11.0471 19.4849 11.0471 19.3504V14.3418C11.0471 14.2073 11.1641 14.0973 11.3071 14.0973H13.1869C13.3299 14.0973 13.4469 14.2073 13.4469 14.3418V19.3504ZM5.46743 6.82022C5.46743 6.69556 5.57403 6.59533 5.70663 6.59533H17.7968C17.9294 6.59533 18.036 6.69556 18.036 6.82022C18.036 6.94489 17.9294 7.04511 17.7968 7.04511H5.70663C5.57403 7.04511 5.46743 6.94489 5.46743 6.82022ZM17.7968 9.68511H5.70663C5.57403 9.68511 5.46743 9.58489 5.46743 9.46022C5.46743 9.33556 5.57403 9.23533 5.70663 9.23533H17.7968C17.9294 9.23533 18.036 9.33556 18.036 9.46022C18.036 9.58489 17.9294 9.68511 17.7968 9.68511Z'
          fill='url(#paint0_linear_12280_31223)'
          stroke='url(#paint1_linear_12280_31223)'
          strokeWidth='0.8'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_31223'
          x1='6.72739'
          y1='2.50015'
          x2='17.8829'
          y2='20.7936'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_31223'
          x1='6.72739'
          y1='2.50015'
          x2='17.8829'
          y2='20.7936'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_31223'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoteGraph;
